export default __webpack_public_path__ + "static/media/8.a595e856.jpg";